import React from 'react';
import PageContainer from '../PageContainer/PageContainer';
import ContentContainer from '../ContentContainer/ContentContainer';
import TabBar, { type TabItem } from '../TabBar/TabBar';
import styles from './AdminPageLayout.module.css';

interface AdminPageShellProps {
  children: React.ReactNode;
  className?: string;
}

interface AdminTabbedPanelProps {
  tabs: readonly TabItem[] | TabItem[];
  activeKey: string;
  onTabChange: (key: string) => void;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  tabBarClassName?: string;
  padded?: boolean;
}

interface AdminContentPanelProps {
  children: React.ReactNode;
  className?: string;
  padded?: boolean;
  standalone?: boolean;
}

const joinClasses = (...classes: Array<string | false | null | undefined>) => (
  classes.filter(Boolean).join(' ')
);

export const AdminPageShell: React.FC<AdminPageShellProps> = ({ children, className }) => (
  <PageContainer className={joinClasses(styles.container, className)}>
    <div className={styles.shell}>{children}</div>
  </PageContainer>
);

export const AdminContentPanel: React.FC<AdminContentPanelProps> = ({
  children,
  className,
  padded = true,
  standalone = true,
}) => (
  <ContentContainer
    className={joinClasses(
      styles.contentBg,
      padded && styles.contentPadded,
      standalone && styles.contentStandalone,
      className,
    )}
  >
    {children}
  </ContentContainer>
);

export const AdminTabbedPanel: React.FC<AdminTabbedPanelProps> = ({
  tabs,
  activeKey,
  onTabChange,
  children,
  actions,
  className,
  contentClassName,
  tabBarClassName,
  padded = true,
}) => (
  <div className={joinClasses(styles.panel, className)}>
    <TabBar
      tabs={tabs}
      activeKey={activeKey}
      onTabChange={onTabChange}
      variant="pill"
      actions={actions}
      className={joinClasses(styles.tabBarReset, tabBarClassName)}
    />
    <AdminContentPanel
      padded={padded}
      standalone={false}
      className={contentClassName}
    >
      {children}
    </AdminContentPanel>
  </div>
);

export default AdminPageShell;
